import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useAssessmentData } from './useAssessmentData';

/**
 * Main hook for assessment results
 * Orchestrates data fetching and state management
 */
export const useAssessmentResults = (assessmentId) => {
  const { user } = useAuth();
  const isUser = user?.role === 'user';
  
  const {
    assessment,
    recommendations,
    benchmarkData,
    loading,
    error,
    fetchAssessmentResults
  } = useAssessmentData(assessmentId);

  const [activeTab, setActiveTab] = useState('executive-summary');

  // Fetch data when assessmentId changes
  useEffect(() => {
    if (assessmentId) {
      fetchAssessmentResults();
    }
  }, [assessmentId, fetchAssessmentResults]);

  return {
    // Data
    assessment,
    recommendations,
    benchmarkData,
    
    // State
    loading,
    error,
    activeTab,
    setActiveTab,
    isUser
  };
};

